
import { ref, onMounted } from "vue";
import { debouncedWatch, useSessionStorage } from "@vueuse/core";
import { usePlugin } from "@/plugins";
import { GetEmployeeResponse, Employee } from "@/types";
import BackButton from "@/components/BackButton.vue";
export default {
  name: "CourseType",
  components: { BackButton },
  setup() {
    const { error, axios, setLoading, onRouterPush } = usePlugin();

    const employeeTable = ref(null);
    const employees = ref<Employee[]>([]);
    const searchString = useSessionStorage("employee-searchString", "");

    // const filteredCourseType = computed(() => {
    //   if (!searchString.value) return courseTypes.value;
    //   const fuse = new Fuse(courseTypes.value, {
    //     keys: ["courseTypeId", "description"],
    //   });
    //   const searchResult = fuse.search(searchString.value);
    //   return searchResult.map((x) => x.item);
    // });

    const loadEmployees = async () => {
      setLoading(true);
      try {
        const result = await axios.post<GetEmployeeResponse>(
          "api/v1/services/employee/get",
          { searchString: searchString.value }
        );
        employees.value = result.data.employees ?? [];
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    const onShowEmployee = (id: string) => {
      onRouterPush({ name: "employee", params: { id: id } });
    };

    onMounted(async () => {
      await loadEmployees();
    });

    debouncedWatch(searchString, loadEmployees, { debounce: 500 });
    return {
      employeeTable,
      employees,
      searchString,
      onShowEmployee,
    };
  },
};
